import React from 'react';
import { motion } from 'framer-motion';

const AuthorSection = () => {
  return (
    <section className="py-24 bg-black border-b border-gray-800 overflow-hidden relative">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none">
        <div className="absolute top-1/4 -left-20 w-96 h-96 bg-green-500 rounded-full blur-[120px]"></div>
        <div className="absolute bottom-1/4 -right-20 w-96 h-96 bg-pbi-yellow rounded-full blur-[120px]"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-16 max-w-6xl mx-auto">
          
          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="lg:w-1/2 relative"
          >
            <div className="relative group">
              {/* Photo Frame */}
              <div className="absolute -inset-4 bg-gradient-to-tr from-green-600 to-pbi-yellow rounded-2xl opacity-20 group-hover:opacity-40 transition-opacity blur-sm"></div>
              
              <div className="relative z-10 rounded-2xl overflow-hidden border-2 border-gray-800 shadow-2xl">
                {/* Updated with Fathima Dhasnim Nisha's provided photo */}
                <img 
                  src="https://media-manager-c.questera.ai/greta-media/d1e1f795f547d188310881b3e1dfad84afccd53626664f205958a3becb1b00f4f5d96fb34b3d15472c5f30d572e92287/images/aW1hZ2UvanBlZw==/450378963c1fba9d000be9f9f5801a9a.jpeg" 
                  alt="Fathima Dhasnim Nisha" 
                  className="w-full h-[600px] object-cover object-center hover:scale-105 transition-transform duration-700"
                />
              </div>
              
              {/* Experience Floating Badge */}
              <motion.div 
                animate={{ y: [0, -10, 0] }}
                transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
                className="absolute -bottom-10 -right-6 bg-green-600 text-white p-8 rounded-3xl shadow-[0_20px_50px_rgba(22,163,74,0.4)] z-20 border-4 border-black text-center"
              >
                <div className="text-5xl font-black leading-none">16+</div>
                <div className="text-xs font-bold uppercase tracking-widest mt-2">Years Tech<br/>Leadership</div>
              </motion.div>
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="lg:w-1/2"
          >
            <div className="inline-flex items-center gap-2 bg-green-500/10 border border-green-500/30 text-green-500 px-5 py-2 rounded-full text-xs font-black uppercase tracking-widest mb-8">
              <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
              The Expert Behind The Blueprint
            </div>
            
            <h2 className="text-5xl font-black text-white mb-4 leading-tight">
              Fathima Dhasnim <span className="text-pbi-yellow">Nisha</span>
            </h2>
            <p className="text-xl text-gray-400 mb-8 font-medium">
              Senior Software Developer & Corporate Trainer
            </p>
            
            <div className="space-y-6 text-gray-300 text-lg leading-relaxed">
              <p>
                With a stellar career spanning over <strong>16 years</strong> in the software development industry, Fathima has become a beacon for international students navigating the competitive US job market.
              </p>
              <p>
                She doesn't just teach technical skills; she provides the <strong>strategic corporate logic</strong> required to land roles that offer H1B sponsorship and six-figure salaries.
              </p>
              <div className="bg-gray-900/50 p-6 rounded-2xl border border-gray-800 relative">
                <i className="fa-solid fa-quote-left text-pbi-yellow text-3xl absolute -top-4 -left-2 opacity-50"></i>
                <p className="italic text-gray-200">
                  "My goal is to stop the cycle of underemployment for international scholars. You have the degree; I give you the key to the corporate door."
                </p>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-6 mt-10">
              <div className="flex flex-col gap-1">
                <span className="text-3xl font-black text-white">5,000+</span>
                <span className="text-xs font-bold text-green-500 uppercase tracking-widest">Students Mentored</span>
              </div>
              <div className="flex flex-col gap-1">
                <span className="text-3xl font-black text-white">92%</span>
                <span className="text-xs font-bold text-pbi-yellow uppercase tracking-widest">Placement Rate</span>
              </div>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default AuthorSection;